import { CardElement, CardNumberElement } from "@stripe/react-stripe-js";

/**
 * Confirm Stripe checkout after /admin/subscription/create.
 * Trials return setup_client_secret (confirmCardSetup / 3DS).
 * Paid checkouts return client_secret (confirmCardPayment).
 * $0 invoices (and some trials with no pending setup) skip confirmation.
 *
 * Signup payment uses split CardNumber/Expiry/Cvc fields.
 * In-app CardForm still uses the combined CardElement.
 */
export function getCheckoutCard(elements) {
  if (!elements || typeof elements.getElement !== "function") {
    return null;
  }
  const lookup = (type) => {
    try {
      return elements.getElement(type) || null;
    } catch (err) {
      return null;
    }
  };
  return (
    lookup(CardNumberElement) ||
    lookup("cardNumber") ||
    lookup(CardElement) ||
    lookup("card") ||
    null
  );
}

export async function confirmStripeCheckout({
  stripe,
  elements,
  clientSecret,
  setupClientSecret,
  cardholderName,
}) {
  const card = getCheckoutCard(elements);
  const billingDetails = cardholderName
    ? { billing_details: { name: cardholderName } }
    : {};

  if (setupClientSecret) {
    const result = await stripe.confirmCardSetup(setupClientSecret, {
      payment_method: card ? { card, ...billingDetails } : undefined,
    });
    if (result.error) {
      return { error: result.error };
    }
    const status = result.setupIntent?.status;
    if (status && status !== "succeeded" && status !== "processing") {
      return {
        error: { message: "Card could not be confirmed. Please try again." },
      };
    }
    return { error: null };
  }

  if (clientSecret) {
    const result = await stripe.confirmCardPayment(clientSecret, {
      payment_method: card ? { card, ...billingDetails } : undefined,
    });
    if (result.error) {
      return { error: result.error };
    }
    if (result.paymentIntent?.status !== "succeeded") {
      return {
        error: {
          message: "Payment could not be confirmed. Please try again or contact support.",
        },
      };
    }
    return { error: null };
  }

  return { error: null };
}
